@for (data of dataEmailHistory; track data; let i = $index) {
  <div class="email-history  pl-1 pr-1">
    <div class="email-history-item">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <div class="activities-content-board truncate">
            <span class="text-title">
              Asunto:
            </span>
            <span class="ms-1" [title]="data.subject">
              {{data.subject}}
            </span>
          </div>
          <div class="activities-content-board truncate">
            <span class="text-title">
              Para:
            </span>
            <span class="ms-1" [title]="data.email">
              {{data.email}}
            </span>
          </div>
          <div class="activities-content-board truncate">
            <span class="text-title">
              De:
            </span>
            <span [title]="(data.sentby || '') + (data.useremail ? ' <' + data.useremail + '>' : '')">
              {{ data.sentby }}{{ data.useremail ? ' - ' + data.useremail : '' }}
            </span>
          </div>
        </div>
        <ng-template #start>
          <header class="text-title mt-1">
            <span>Mensaje</span>
            <hr>
            </header>
            <main class="text-subtitle text-left" [innerHTML]="data.content? data.content : 'No indica'"></main>
            <main></main>
          </ng-template>
          <div class="mr-2" [id]="'info-'+i" [ngbTooltip]="start" triggers="click:blur">
            <a>
              <i class="fa fa-info-circle"></i>
            </a>
          </div>
        </div>
        <div class="notes-footer d-flex align-items-start mt-1">
          @if (!data.completed) {
            <span class="activities-subtitle badge bg-danger">
              Mensaje no enviado
            </span>
          }
          @if (data.completed) {
            <span class="activities-subtitle badge bg-success">
              Mensaje enviado
            </span>
          }
        </div>
        <div class="notes-footer d-flex justify-content-between align-items-end mt-1">
          <div class="notes-footer-left d-flex align-items-center">
            <div class="notes-due-date mr-5">
              <i class="far fa-clock font-size-small mr-1"></i>
              <span class="font-size-small">{{formatDate(data.createdat)}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  }